import React, { FC, useState, useCallback, useRef, useEffect } from "react"
import { observer } from "mobx-react-lite"
import { ViewStyle, View, Appearance } from "react-native"
import { Screen, Button, FirstPriceForm } from "../../../../components"
// import { useStores } from "../../models"
import { color } from "../../../../theme"
import { useStores } from "../../../../models"
import { FormikProps, FormikValues } from "formik"
import { navigate } from "../../../../navigators"
import JalaAnalytic from "../../../../utils/jala-analytic"

const ROOT: ViewStyle = {
  backgroundColor: color.palette.white,
  flexGrow: 1,
  // paddingHorizontal: 16,
  paddingTop: 23
}

const BUTTON_CONTAINER: ViewStyle = {
  paddingVertical: 8,
  paddingHorizontal: 16,
  flex: 1,
  justifyContent: 'flex-end',
}

export const CreateShrimpPriceFirstScreen: FC<{ colorScheme?: "light" | "dark" }> = observer(function CreateShrimpPriceFirstScreen(props) {
  const { colorScheme = "light" || Appearance.getColorScheme() } = props
  const { userStore: { user } } = useStores()
  const [ isError, setIsError ] = useState<boolean>(true);

  const priceForm = useRef<FormikProps<FormikValues>>()
  const priceFormRef = useCallback((node) => {
    priceForm.current = node;
    if (priceForm.current) setIsError(!(priceForm.current.dirty && priceForm.current.isValid))
  }, [])

  const onSubmit = useCallback((data) => {
    // samplingStore.setLoading(true);
    // if (params.route === "add") samplingStore.storeSampling(newData).then(() => goBack(props.componentId));
    // else samplingStore.updateSampling(data).then(() => goBack(props.componentId));
    // shrimpPriceStore.set('baseData', data)
    navigate('Home.Stack', 'Home.Price.Create.Second', {
      contact: data.phone,
      species_id: data.species,
      country_id: data.country,
      region_id: data.region_id,
      region_ids: data.city
    })
  }, [])

  const handleSubmit = useCallback((event) => {
    if (priceForm.current) priceForm.current.handleSubmit(event)
  }, [])

  useEffect(() => {
    JalaAnalytic.log('Mobile app: visit form shrimp price - add', user);
  }, [user])

  return (
    <Screen
      style={ROOT}
      preset="scroll"
      colorScheme={colorScheme}
      backgroundBar={colorScheme === "light" ? color.primary : undefined}
      statusBar={colorScheme === "light" ? "light-content" : "dark-content"}
      hideOnBlurred={false}
    >
      <FirstPriceForm
        colorScheme={colorScheme}
        user={user}
        // initialValues={{ name: user ? user.name : '-', phone: user ? user.phone : '' }}
        innerRef={priceFormRef}
        onSubmit={onSubmit}
      />
      <View style={BUTTON_CONTAINER}>
        <Button
          testID="jala:id/save-button"
          tx="shrimpPriceScreen.next"
          colorScheme={colorScheme}
          disabled={isError}
          onPress={handleSubmit}
        />
      </View>
    </Screen>
  )
})
